import './articleSingle.scss';

import React from 'react';

import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import arrowDown from '../../images/arrowDown.png';
import arrowUp from '../../images/arrowUp.png';
import GatsbyImageWrapper from '../GatsbyImageWrapper';


export default function ArticleSingle(props: { article: any }) {
    const { article } = props;

    const attributes = article?.attributes;
    const { navigateTranslated, currentLocale } = usePageLocalization();

    return (
        <div
            className='articleBlock'
            onClick={() => navigateTranslated(`/articles/${article.code}`)}
        >
            <div className='articleBlockImage'>
                <GatsbyImageWrapper
                    fields={article.fields}
                    propertyToGet='thumbnail'
                />
            </div>
            {attributes.blog_subject && (
                <div className='cat'>
                    <span>
                        {attributes.blog_subject.values[0][currentLocale]}
                    </span>
                </div>
            )}
            {article.title && <h4>{article.title[currentLocale]}</h4>}
            {attributes.content_short && (
                <div className='hiddenDesc'>
                    <p>{attributes.content_short.values[0][currentLocale]}</p>
                </div>
            )}
            <img className='articleBlockArrowDown' src={arrowDown} alt='' />
            <img className='articleBlockArrowUp' src={arrowUp} alt='' />
        </div>
    );
}
